(() => {
    document.addEventListener('DOMContentLoaded', function () {
        const hideOmnibus = function ($this) {
            $( '.omnibus-variable' ).each(function () {
                if( !$(this).hasClass('hidden') ) {
                    $(this).addClass('hidden');
                }
            })
        };

        const showOmnibus = function (variation_id) {
            $(`.omnibus-variable[data-variation="${variation_id}"]`).each(function () {
                $(this).removeClass('hidden');
            })
        };
        
        $('.single_variation_wrap').on('show_variation', function ( event, variation ) {
            hideOmnibus($(this));
            showOmnibus(variation?.variation_id);
        } );

        if ($('.bundled_product_summary').length > 0) {
            $('.bundle_wrap').hide();
            setTimeout(function () {
                $('.bundle_wrap .bundle_price, .bundle_wrap .bundle_error').hide();
                $('.bundle_wrap').show();

            }, 500)
        }
    });
})();